import apiConfig from "constants/apiConfig"
import axiosClient from "utils/axiosClient"

export const updateAccountType = async (agencyId: string, type: string) => {
    const response = await axiosClient.post(apiConfig.UPDATE_ACCOUNT_TYPE.url.replace('<agencyId>', agencyId), { type });
    return response.data;
}

export const skipOnboardingStep = async (agencyId: string, step: string) => {
    const response = await axiosClient.post(apiConfig.SKIP_ONBOARDING_STEP.url.replace('<agencyId>', agencyId).replace('<step>', step));
    return response.data;
}

export const updateAccountWebsite = async (agencyId: string, website_url: string) => {
    const response = await axiosClient.post(apiConfig.UPDATE_ACCOUNT_WEBSITE.url.replace('<agencyId>', agencyId), { website_url });
    return response.data;
}

export const fetchAgencyMetadataSuggestions = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_AGENCY_METADATA_SUGGESTIONS.url.replace('<agencyId>', agencyId));
    return response.data;
}